import React from "react";
import { useField } from "formik";

function TextInputV2({
  label,
  required = false,
  type = "text",
  className = "readonly-box",
  ...props
}) {
  const [field, meta] = useField(props);

  return (
    <div>
      {label && (
        <label htmlFor={props.name} className="discharge-screen-label">
          {label} {required && <span>*</span>}
        </label>
      )}

      <input
        {...field}
        {...props}
        type={type}
        className={className}
      />

      {meta.touched && meta.error && (
        <div className="error mt-1">
          {meta.error}
        </div>
      )}
    </div>
  );
}

export default TextInputV2;
